<template>
  <!-- 版本三：左侧系统连接图，右侧选项卡 -->
  <div id="kisaeDetail">
    <el-row :gutter="40" style="background: #044a8b;">
      <el-col :xs="24" :sm="24" :lg="10" class="card-panel-col" style="padding:20px;">
        <div class="systemFlowWarp" style="">
          <div class="systemYhubDiv" @click="goToTabPan('yhub')" /> <!--ac-->
          <div class="systemAcDiv" @click="goToTabPan('ac')" /> <!--ac-->
          <div class="systemDcDiv" @click="goToTabPan('dc')" /> <!--dc-->
          <div class="systemBidDiv" @click="goToTabPan('bid')" /> <!--双向：bid-->
          <div class="systemInvDiv" @click="goToTabPan('inv')" /> <!--单向：inv-->
          <img v-if="activeDevice == 'Yhub'" class="systemFlowImg" src="@/assets/images/kisae/flowChart/yhubFlow.gif" alt="" style="width: 100%;">
          <img v-else-if="activeDevice.indexOf('acCharge')>-1" class="systemFlowImg" src="@/assets/images/kisae/flowChart/systemAcFlow.gif" alt="" style="width: 100%;">
          <img v-else-if="activeDevice.indexOf('dcCharge')>-1" class="systemFlowImg" src="@/assets/images/kisae/flowChart/systemDcFlow.gif" alt="" style="width: 100%;">
          <img v-else-if="activeDevice.indexOf('bidrectional')>-1" class="systemFlowImg" src="@/assets/images/kisae/flowChart/systemBidFlow.gif" alt="" style="width: 100%;">
          <img v-else-if="activeDevice.indexOf('inverter')>-1" class="systemFlowImg" src="@/assets/images/kisae/flowChart/systemInvFlow.gif" alt="" style="width: 100%;">
          <!-- <img v-if="activeDevice==''" src="@/assets/images/kisae/systemAllFlow.jpg" alt="" style="width: 100%;"> -->
        </div>
        <div class="systemFlowRemarkWarp">
          <span>Remark</span>
          <div>
            <p>Red Line = INPUT</p>
            <p>Blue Line = OUTPUT</p>
          </div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :lg="14" class="card-panel-col" style="padding:0;background: #175d9b;">
        <!-- 选项卡 -->
        <i v-if="isShowEdit" class="el-icon-edit editDeviceI" @click="openDelete" />
        <i v-else class="el-icon-close editDeviceI" @click="isShowEdit=true;isOpenDelete=false" />
        <!-- <el-button type="primary" icon="el-icon-close" style="vertical-align: top;float: right;" @click="openDelete" /> -->
        <el-tabs v-model="activeDevice" type="border-card" :closable="isOpenDelete" @edit="removeTab">
          <el-tab-pane label="BATTERY MONITOR" name="Yhub" style="position:relative;">
            <yhubTabPaneTem :yhub-tab-pane-info="yhubTabPaneInfo" :yhub-sn="yhubSn" />
          </el-tab-pane>
          <el-tab-pane v-for="(device,index1) in tableData" :key="device.nameS+'-'+device.id" :label="device.name" :name="device.nameS+'-'+device.id" style="position:relative;">
            <acChargeSetTem v-if="device.deviceType=='d'" style="margin: 35px 0 10px;" :online="device.MqttOnline||false" />
            <dcdcDetailSetTem v-if="device.deviceType=='e'" style="margin: 35px 0 10px;" :online="device.MqttOnline||false" />
            <bidirectionalSetTem v-if="device.deviceType=='b'" style="margin: 35px 0 10px;" :online="device.MqttOnline||false" />
            <inverterSetTem v-if="device.deviceType=='c'" style="margin: 35px 0 10px;" :online="device.MqttOnline||false" />
            <acTabPaneTem v-if="device.deviceType=='d'" :ac-tab-pane-info="acTabPaneInfo" :ac-sn="acSn" />
            <dcTabPaneTem v-if="device.deviceType=='e'" :dc-tab-pane-info="dcTabPaneInfo" :dc-sn="dcSn" />
            <bidTabPaneTem v-if="device.deviceType=='b'" :bid-tab-pane-info="bidTabPaneInfo" :bid-sn="bidSn" />
            <invTabPaneTem v-if="device.deviceType=='c'" :inv-tab-pane-info="invTabPaneInfo" :inv-sn="invSn" />
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
  </div>
</template>

<script>

import { detail, GetRealTimeData, deleteSystem, getDMTCfg, getIvtCfg, getCBBCfg, getTCCfg } from '@/api/kisae'
import i18n from '@/i18n'
import acChargeSetTem from '@/views/charge/acChargeSetTem'
import dcdcDetailSetTem from '@/views/dcdc/dcdcDetailSetTem'
import bidirectionalSetTem from '@/views/bidirectional/bidirectionalSetTem'
import inverterSetTem from '@/views/inverter/inverterSetTem'
import yhubTabPaneTem from '@/views/kisae/yhubTabPaneTem'
import dcTabPaneTem from '@/views/kisae/dcTabPaneTem'
import acTabPaneTem from '@/views/kisae/acTabPaneTem'
import bidTabPaneTem from '@/views/kisae/bidTabPaneTem'
import invTabPaneTem from '@/views/kisae/invTabPaneTem'
import { updateTime } from '@/utils/updateTime.js'

export default {
  name: 'DashboardAdmin',
  components: {
    yhubTabPaneTem, dcTabPaneTem, acTabPaneTem, bidTabPaneTem, invTabPaneTem, acChargeSetTem, dcdcDetailSetTem, bidirectionalSetTem, inverterSetTem
  },
  data() {
    return {
      activeDevice: 'Yhub',
      isShowYHUB: true,
      isShowAc: true,
      isShowDc: true,
      isShowInv: true,
      isShowBid: true,
      yhubSn: '',
      acSn: '',
      dcSn: '',
      bidSn: '',
      invSn: '',
      yhubTabPaneInfo: {// 传给子组件
        timeAgoRes: null,
        batteryCapacity: '',
        level: '',
        currentCharging: '',
        currentUsing: '',
        voltageRaw: ''
      },
      acTabPaneInfo: {// 传给子组件
        timeAgoRes: null
      },
      dcTabPaneInfo: {// 传给子组件
        timeAgoRes: null
      },
      bidTabPaneInfo: {// 传给子组件
        timeAgoRes: null
      },
      invTabPaneInfo: {// 传给子组件
        timeAgoRes: null
      },
      tableData: [],
      tabPaneNameArr: [],
      isOpenDelete: false,
      tabIndex: 1,
      isShowEdit: true
    }
  },
  computed: {
    storeYhubmqtt() {
      return this.$store.state.yhubmqtt// 需要监听的数据
    }
  },
  watch: {
    storeYhubmqtt: {
      handler(newValue, oldValue) {
        this.yhubmqtt = newValue
        this.MQTT()
      },
      deep: true
    },
    tableData: {
      handler(newValue, oldValue) {
        this.tableData = newValue
      },
      deep: true,
      immediate: true
    },
    yhubTabPaneInfo: {
      handler(newValue, oldValue) {
        this.yhubTabPaneInfo = newValue
      },
      deep: true,
      immediate: true
    },
    acTabPaneInfo: {
      handler(newValue, oldValue) {
        this.acTabPaneInfo = newValue
      },
      deep: true,
      immediate: true
    },
    dcTabPaneInfo: {
      handler(newValue, oldValue) {
        this.dcTabPaneInfo = newValue
      },
      deep: true,
      immediate: true
    },
    bidTabPaneInfo: {
      handler(newValue, oldValue) {
        this.bidTabPaneInfo = newValue
      },
      deep: true,
      immediate: true
    },
    invTabPaneInfo: {
      handler(newValue, oldValue) {
        this.invTabPaneInfo = newValue
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.queryList()
    GetRealTimeData({ mcuId: this.$route.query.mcuId }).then(res => {})
    setTimeout(() => {
      this.watchChangeSize()
    }, 500)
    //  监听窗口大小改变（先移除再监听，防止出错）
    window.removeEventListener('resize', e => {
      this.watchChangeSize()
    }, false)
    window.addEventListener('resize', e => {
      this.watchChangeSize()
    }, false)
  },
  created() {
    this.tableData = JSON.parse(sessionStorage.getItem('kisaeRelationDeviceList'))
    this.tabPaneNameArr = []
    this.tableData.forEach(v => {
      v.MqttOnline = false
      console.log(this.tabPaneNameArr)
      switch (v.deviceType) {
        case 'd': {
          v.name = 'AC-DC CHARGER'
          v.nameS = 'acCharge'
          if (!this.tabPaneNameArr.some(m => { return m.key == 'ac' })) { // 如果tabPaneNameArr没有ac，才添加
            this.tabPaneNameArr.push({ key: 'ac', value: v.nameS + '-' + v.id })
          }
          break
        }

        case 'e': {
          v.name = 'DC-DC CHARGER'
          v.nameS = 'dcCharge'
          if (!this.tabPaneNameArr.some(m => { return m.key == 'dc' })) {
            this.tabPaneNameArr.push({ key: 'dc', value: v.nameS + '-' + v.id })
          }
          break
        }
        case 'b': {
          v.name = 'BIDRECTIONAL'
          v.nameS = 'bidrectional'
          if (!this.tabPaneNameArr.some(m => { return m.key == 'bid' })) {
            this.tabPaneNameArr.push({ key: 'bid', value: v.nameS + '-' + v.id })
          }
          break
        }
        case 'c': {
          v.name = 'INVERTER'
          v.nameS = 'inverter'
          if (!this.tabPaneNameArr.some(m => { return m.key == 'inv' })) {
            this.tabPaneNameArr.push({ key: 'inv', value: v.nameS + '-' + v.id })
          }
          break
        }
      }
    })
  },
  destroyed: function() {
    window.removeEventListener('resize', e => {
      this.watchChangeSize()
    }, false)
  },
  methods: {
    watchChangeSize() {
      var offsetWid = document.getElementsByClassName('systemFlowImg')[0].clientWidth
      var offsetHei = document.getElementsByClassName('systemFlowImg')[0].clientHeight
      if (offsetHei == 0 && offsetWid != 0)offsetHei = Math.round(offsetWid * 0.96)
      document.getElementsByClassName('systemYhubDiv')[0].style.height = offsetHei * 0.16 + 'px'
      document.getElementsByClassName('systemAcDiv')[0].style.height = offsetHei * 0.2 + 'px'
      document.getElementsByClassName('systemDcDiv')[0].style.height = offsetHei * 0.16 + 'px'
      document.getElementsByClassName('systemBidDiv')[0].style.height = offsetHei * 0.12 + 'px'
      document.getElementsByClassName('systemInvDiv')[0].style.height = offsetHei * 0.13 + 'px'
    },
    goToTabPan(attr) {
      if (attr == 'yhub') this.activeDevice = 'Yhub'
      this.tabPaneNameArr.forEach(v => {
        if (v.key == attr) this.activeDevice = v.value
      })
    },
    acRefresh() {
      getTCCfg({ mcuId: this.$route.query.mcuId }).then(res => {})
    },
    dcRefresh() {
      getDMTCfg({ mcuId: this.$route.query.mcuId }).then(res => {})
    },
    bidRefresh() {
      getIvtCfg({ mcuId: this.$route.query.mcuId }).then(res => {})
    },
    invRefresh() {
      getCBBCfg({ mcuId: this.$route.query.mcuId }).then(res => {})
    },
    queryList() {
      var param = {
        mcuId: this.$route.query.mcuId,
        stime: new Date().getTime() - 24 * 60 * 60 * 1000
      }
      // 设备信息
      detail(param).then(res => {
      // 设备信息详情
        if (res.resultCode == 1001) {
          this.basicinfo = res.resultModel
          this.tableData = []
          this.tableData = res.resultModel.relationDeviceList
          this.tabPaneNameArr = []
          this.tableData.forEach(v => {
            v.MqttOnline = false
            switch (v.deviceType) {
              case 'd': {
                v.name = 'AC-DC CHARGER'
                v.nameS = 'acCharge'
                if (!this.tabPaneNameArr.some(m => { return m.key == 'ac' })) { // 如果tabPaneNameArr没有ac，才添加
                  this.tabPaneNameArr.push({ key: 'ac', value: v.nameS + '-' + v.id })
                }
                break
              }

              case 'e': {
                v.name = 'DC-DC CHARGER'
                v.nameS = 'dcCharge'
                if (!this.tabPaneNameArr.some(m => { return m.key == 'dc' })) {
                  this.tabPaneNameArr.push({ key: 'dc', value: v.nameS + '-' + v.id })
                }
                break
              }
              case 'b': {
                v.name = 'INVERTER/CHARGER'
                v.nameS = 'bidrectional'
                if (!this.tabPaneNameArr.some(m => { return m.key == 'bid' })) {
                  this.tabPaneNameArr.push({ key: 'bid', value: v.nameS + '-' + v.id })
                }
                break
              }
              case 'c': {
                v.name = 'INVERTER'
                v.nameS = 'inverter'
                if (!this.tabPaneNameArr.some(m => { return m.key == 'inv' })) {
                  this.tabPaneNameArr.push({ key: 'inv', value: v.nameS + '-' + v.id })
                }
                break
              }
            }
          })
          // yhub详情
          if (res.resultModel.lastRecordData) {
            this.yhubSn = res.resultModel.yhubSn
            this.yhubTabPaneInfo = res.resultModel.lastRecordData
            this.yhubTabPaneInfo.timeAgoRes = res.resultModel.lastRecordData.yhubStimeTs
            this.yhubTabPaneInfo.batteryCapacity = res.resultModel.batteryCapacity
            this.yhubTabPaneInfo.level = res.resultModel.level
            this.yhubTabPaneInfo.dataFrom = 'api'
          }
          // info
          if (this.tableData && this.tableData.length > 0) {
            this.tableData.forEach((m, i) => {
              //  设备类型：a yhub，b Inverter 双向逆变器，c CBB (单向逆变器)，d TC(AC充电器)，e DMT(DCDC充电器)
              if (m.deviceType == 'd') { // d TC(AC充电器)
                m.acInfo = m.lastTCcloud || {}
                // console.log(m)
                this.acTabPaneInfo.timeAgoRes = m.acInfo.triggertime // 假数据
                // this.acTabPaneInfo.timeAgo = updateTime(m.timeAgoRes)
                this.acSn = m.yhubSn
                this.acTabPaneInfo.monLine = false
                this.acTabPaneInfo.dataFrom = 'api'
              } else if (m.deviceType == 'e') { // e DMT(DCDC充电器)
                m.dcInfo = m.lastDMTcloud || {}
                this.dcTabPaneInfo.timeAgoRes = m.dcInfo.triggertime // 假数据
                this.dcSn = m.yhubSn
                this.dcTabPaneInfo.monLine = false
                this.dcTabPaneInfo.dataFrom = 'api'
              } else if (m.deviceType == 'b') { // b Inverter 双向逆变器
                m.bidInfo = m.lastInverter || {}
                this.bidTabPaneInfo.timeAgoRes = m.bidInfo.triggertime // 假数据
                this.bidSn = m.yhubSn
                this.bidTabPaneInfo.monLine = false
                this.bidTabPaneInfo.dataFrom = 'api'
              } else if (m.deviceType == 'c') { // c CBB (单向逆变器)
                m.invInfo = m.lastCBBcloud || {}
                this.invTabPaneInfo.timeAgoRes = m.invInfo.triggertime // 假数据
                this.invSn = m.yhubSn
                this.invTabPaneInfo.monLine = false
                this.invTabPaneInfo.dataFrom = 'api'
              }
            })
          }
        }
      })
    },
    goToReport() {
      var routeData, lastUpdateTime
      if (this.basicinfo.lastRecordData && this.basicinfo.lastRecordData.yhubStimeTs) { lastUpdateTime = this.basicinfo.lastRecordData.yhubStimeTs } else { lastUpdateTime = Date.parse(new Date()) }
      routeData = this.$router.resolve({
        path: '/allDevices/yhubReport',
        query: {
          mcuId: this.basicinfo.mcuId,
          latest: lastUpdateTime
        }
      })
      window.open(routeData.href, '_self')
    },
    MQTT() {
      if (this.yhubmqtt) {
        // console.log('yhubmqtt-----', this.yhubmqtt)
        if (!this.yhubmqtt.topic || this.yhubmqtt.topic.indexOf(this.$route.query.mcuId) == -1) return
        if (this.yhubmqtt.payload === 'mCan') {
          var mCanData = this.yhubmqtt.mCan
          if (!mCanData) return
          if (mCanData.payload === 'mTCRRealTimeData') { // d ac
            this.acChargeMqttData = mCanData.mTCRRealTimeData // 实时详情、警告
            console.log('this.acChargeMqttData-ac充电器--kisae-----', this.acChargeMqttData)
            if (!this.acChargeMqttData) return
            if (this.acChargeMqttData) {
              this.tableData.forEach((m, i) => {
                if (m.deviceType == 'd') { // d TC(AC充电器)
                  this.acTabPaneInfo = this.acChargeMqttData
                  this.acTabPaneInfo.dataFrom = 'mqtt'
                  if (this.acTabPaneInfo.connection === 1) { // 设备状态 1：连接 0：断开
                    m.MqttOnline = true
                  } else {
                    m.MqttOnline = false
                  }
                }
              })
            }
          }
          if (mCanData && mCanData.payload === 'mDMTRealTimeData') { // e  dc
            this.dcdcMqttData = mCanData.mDMTRealTimeData // 实时详情、警告
            console.log('this.mDMTRealTimeData-dc充电器--kisae---', this.dcdcMqttData)
            if (!this.dcdcMqttData) return
            if (this.dcdcMqttData) {
              this.tableData.forEach((m, i) => {
                if (m.deviceType == 'e') { // e dc
                  this.dcTabPaneInfo = this.dcdcMqttData
                  this.dcTabPaneInfo.dataFrom = 'mqtt'
                  if (this.dcTabPaneInfo.connection === 1) { // 设备状态 1：连接 0：断开
                    m.MqttOnline = true
                  } else {
                    m.MqttOnline = false
                  }
                }
              })
              this.tableData = [...this.tableData]
            }
          }
          if (mCanData && mCanData.payload === 'mCBBRealTimeData') { // c 单向逆变器
            var cbbMqttData = this.yhubmqtt.mCan.mCBBRealTimeData
            console.log('mCBBRealTimeData-单向逆变器--kisae-----', cbbMqttData)
            if (!cbbMqttData) return
            if (cbbMqttData) {
              this.tableData.forEach((m, i) => {
                if (m.deviceType == 'c') { // c 单向逆变器
                  this.invTabPaneInfo = cbbMqttData
                  this.invTabPaneInfo.dataFrom = 'mqtt'
                  if (!this.invTabPaneInfo.connection) { // 设备状态 0：连接 1：断开
                    m.MqttOnline = true
                  } else {
                    m.MqttOnline = false
                  }
                }
              })
              this.tableData = [...this.tableData]
            }
          }
          var bidData = this.yhubmqtt.mCan.mInverterData // b 双向逆变器
          console.log('inverterData-双向逆变器--kisae---', bidData)
          if (bidData) {
            this.tableData.forEach((m, i) => {
              if (m.deviceType == 'b') {
                this.bidTabPaneInfo = bidData
                this.bidTabPaneInfo.dataFrom = 'mqtt'
                if (this.bidTabPaneInfo.connection === 1) { // 设备状态 1：连接 2：断开
                  m.MqttOnline = true
                } else {
                  m.MqttOnline = false
                }
              }
            })
            this.tableData = [...this.tableData]
          }
        }
        if (this.yhubmqtt.payload === 'mRealTimeData') { // yhub
          if (!this.yhubmqtt.mRealTimeData.dRecord) { return }
          this.yhubTabPaneInfo = this.yhubmqtt.mRealTimeData.dRecord
          this.yhubTabPaneInfo.dataFrom = 'mqtt'
          this.tableData = [...this.tableData]
        }
      }
    },
    openDelete() { // 打开删除功能
      this.isOpenDelete = true
      this.isShowEdit = false
      setTimeout(() => {
        var a = document.querySelectorAll('div.el-tabs__header.is-top')[0]
        var b = a.getElementsByClassName('el-icon-close')
        var c = a.getElementsByClassName('el-tabs__nav-scroll')
        c[0].firstChild.children[0].style.width = '172px' // yhub所在的div
        // b[0].style.display = 'none'// 去掉yhub的删除按钮
      })
    },
    removeTab(targetName, action) {
      this.$confirm('Are you sure to delete the device？', '', {//
        confirmButtonText: 'Confirm', // '确定'
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        deleteSystem({ 'id': targetName.split('-')[1] }).then(res => {
          if (res.resultCode == '1001') {
            this.$message({
              type: 'success',
              message: i18n.t('warningSet.submitted') //
            })
            // this.queryList()
            if (action === 'remove') {
              var tabs = this.tableData
              var activeName1 = this.activeDevice
              if (activeName1 === targetName) {
                tabs.forEach((tab, index) => {
                  if ((tab.nameS + '-' + tab.id) === targetName) {
                    var nextTab = tabs[index + 1] || tabs[index - 1]
                    if (nextTab) {
                      activeName1 = nextTab.nameS + '-' + nextTab.id
                    }
                  }
                })
              }
            }
            this.activeDevice = activeName1
            this.tableData = tabs.filter(tab => (tab.nameS + '-' + tab.id) !== targetName)
          }
        })
      }).catch(() => {})
    },
    deleteDevice(item) {
      this.$confirm('Are you sure to delete the device？', '', {//
        confirmButtonText: 'Confirm', // '确定'
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        deleteSystem({ 'id': item.id }).then(res => {
          if (res.resultCode == '1001') {
            this.$message({
              type: 'success',
              message: i18n.t('warningSet.submitted') //
            })
            // this.queryList()
          }
        })
      }).catch(() => {})
    },
    change(e) {
      this.$forceUpdate()
    },
    decimalToBinary(num) { // 十进制转二进制
      var myNum = num
      var b = []
      while (1) {
        var remainder = num % 2
        b.unshift(remainder)
        num = parseInt(num / 2)
        if (num == 0) break
      }
      var len
      if (myNum < 10) {
        len = 4 - b.length
        for (var i = 0; i < len; i++) {
          b.unshift(0)
        }
      } else if (myNum >= 10 && myNum < 100) {
        len = 8 - b.length
        for (var j = 0; j < len; j++) {
          b.unshift(0)
        }
      }
      return b.reverse()
      // return b
    },
    dataHandling(num) { // 对数字进行处理：如为空，则展示--，如为0，则展示0，其他则除100
      var result
      if (num === '') {
        result = '--'
      } else if (num === 0) {
        result = 0
      } else if ((!num && num != 0) || (num == '--') || (num == '')) {
        result = '--'
      } else {
        result = (num / 100).toFixed(2)
      }
      return result
    },
    dataHandling2(num) { // 对数字进行处理：如为空，则展示--，如为0，则展示0，其他则原值展示
      var result
      if (num === '') {
        result = '--'
      } else if (num === 0) {
        result = 0
      } else if ((!num && num != 0) || (num == '--') || (num == '')) {
        result = '--'
      } else {
        result = num
      }
      return result
    }
  }
}
</script>

<style lang="scss" scoped>
p{
  margin:0
}
</style>
<style lang="scss">
#kisaeDetail{
  //选项卡及里面背景边框等
  .el-tabs--border-card{
    border:none;
    color: #fff;
  }
  .el-tabs__item {
    height: 60px;
  }
  .el-tabs--border-card>.el-tabs__header {
    background-color: #32597a;
    border:none;
  }
  .el-tabs--border-card>.el-tabs__header .el-tabs__item {
    color: #fff;
  }
  .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
    color: #fff;
    background-color: #175d9b;
    border: none;
  }
  .el-tabs--border-card>.el-tabs__header .el-tabs__item {
    border: none;
    align-items: center;
    display: inline-flex;
  }
  .el-tabs--border-card>.el-tabs__content {
    background: #175d9b;
  }
  .paneDivWarp{
    background:#27679e;
    border:1px solid #537da3;
    position: relative;
  }
  .editDeviceI{
    z-index: 999;
    position: relative;
    float: right;
    color: #fff;
    margin: 21px 20px;
  }
  .el-tabs__nav-next, .el-tabs__nav-prev {
    line-height: 60px;
  }
  .el-tabs__item:focus.is-active.is-focus:not(:active){
    box-shadow: none;
  }
  .el-tabs--border-card>.el-tabs__header #tab-Yhub.el-tabs__item.is-active .el-icon-close {//yhub的不显示删除按钮
    display: none;
  }
  .el-tabs--border-card>.el-tabs__header #tab-Yhub.el-tabs__item .el-icon-close {//yhub的不显示删除按钮
    display: none;
  }
  //状态
  .divWarp25{
    width: calc(25% - 4px);
    display: flex;
    text-align: center;
    margin: 10px 0;
    vertical-align: top;
  }
  .paneDivStatusImg{
    width:23%;
  }
  .paneDivStatusImg img{
    width:100%;
    margin-top: 4px;
  }
  .paneDivStatusWarp{
    margin:10px 0;
    display: flex;
    padding: 10px;
  }
  .paneDivStatusP{
    text-align: center;
    margin-left: 5px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .paneDivStatusP p:nth-of-type(2){
    line-height: 23px;
    height: 18px;
  }
  //警告
  .warningWarp{
    .el-table--group::after, .el-table--border::after, .el-table::before,.el-table--group::after, .el-table--border::after, .el-table::before {
      background-color: #27679e;
    }
    .el-table{
      background:none;
    }
    .el-table tr {
      background-color: #27679e;
      font-size: 16px;
    }
    .el-table tr:hover ,.el-table--enable-row-hover .el-table__body tr:hover>td {
      background-color: #27679e;
    }
    .el-table--medium td {
      padding: 20px 1%;
    }
    .el-table--medium td:nth-of-type(3n+1) {
      padding: 20px 0;
    }
    .el-table--medium td:nth-of-type(3n+2) {
      color:#f0bd2a;
    }
    .el-table--medium td:nth-of-type(3n) {
      color:#8bc8fd;
    }
    .el-table__empty-text {
      color: #f0f2f5;
    }
  }
  //流程图
  .flowP{
    line-height: 40px;
    height: 40px;
    padding: 0 10px;
    border-bottom: 1px dashed #537ca3;
    margin-bottom: 10px;
  }
  .flowP span{
    color: #FFEB3B;
  }
  .flowDivWarp{
    width: 80%;
    margin-left: 10%;
    position:relative;
  }
  .flowDataDiv{
    display: inline-block;
    position: absolute;
    width: 80px;
  }
  .flowDataDiv p{
    line-height: 22px;
    height: 22px;
    text-align: center;
  }
  .systemFlowWarp{
    width: 100%;
    position:relative;
  }
  .systemFlowWarp div{
    position: absolute;
  }
  .systemYhubDiv{
    width:18%;
    left: 38.8%;
    top: 82%;
  }
  .systemAcDiv{
    width:11%;
    left: 23%;
    top: 57%;
  }
  .systemDcDiv{
    width:11%;
    left: 23%;
    top: 22%;
  }
  .systemBidDiv{
    width:22%;
    left: 59.8%;
    top: 61%;
  }
  .systemInvDiv{
    width:18%;
    left: 61.4%;
    top: 25%;
  }
  .systemFlowRemarkWarp{
    display: flex;
    align-items: center;
    line-height: 24px;
    color: #fff;
    font-size: 14px;
    margin-top: 10px;
  }
  .systemFlowRemarkWarp>div{
    margin-left: 15px;
  }
}

</style>

